import PRIME_EXT_1 from "./PRIME_EXT_1";
export default {
  PRIME_EXT_1,
};
